import Cookies from 'js-cookie';
import isOnServer from './isOnServer';
import { LevelPriority } from './constants';
/**
 * Checks for a log level override defined as a cookie.
 * This will only  affect client-side logging,
 * as we don't currently pass server-request when initializing this library
 */
const getCookieOverride = () => {
    if (isOnServer())
        return undefined;
    const overrideCookie = Cookies.get('nw-log-level');
    if (!overrideCookie)
        return undefined;
    if (!LevelPriority[overrideCookie])
        return undefined;
    return overrideCookie;
};
export default getCookieOverride;
